/** Writer Trade Organization Dashboard — Title Registry + Welfare Ledger. */
import TradeOrgShell from "../../TradeOrgShell";
import ProducerFeaturePanel from "../producer/ProducerFeaturePanel";
import WorkerFeaturePanel from "../worker/WorkerFeaturePanel";

const ACCENT = "#B981F5";   // violet — creative writers

export default function WriterDashboard() {
  return (
    <TradeOrgShell variantName="Writer" accent={ACCENT}>
      {({ org, quorum }) => (
        <div className="space-y-6" data-testid="writer-panels">
          <ProducerFeaturePanel org={org} quorum={quorum} accent={ACCENT} />
          <WorkerFeaturePanel   org={org} quorum={quorum} accent={ACCENT} />
        </div>
      )}
    </TradeOrgShell>
  );
}
